import { PaymentPlan, IMeta } from 'utils/types';

export const recurringFields = [
  { id: 1, label: 'Monthly', value: 'MONTHLY' },
  { id: 2, label: 'Annual', value: 'ANNUAL' },
  { id: 3, label: 'One Time', value: 'ONE_TIME' },
];

export type PlanTableRow = {
  id: number;
  name: string;
  ofProjects: string;
  ofUsers: string;
  storageLimit: string;
  mohtlyAmount: string;
  annualAmount: string;
  externalProductId: number | null;
  sourcePlan: PaymentPlan;
};

const formatLimit = (value?: number | null): string => {
  if (value == null) {
    return 'Unlimited';
  }

  return String(value);
};

const formatAmountCents = (cents: number): string => {
  const dollars = cents / 100;

  return dollars % 1 === 0 ? `$${dollars.toFixed(0)}` : `$${dollars.toFixed(2)}`;
};

const formatMonthlyAmount = (plan: PaymentPlan): string => {
  if (plan.recurring !== 'MONTHLY') {
    return '—';
  }

  if (plan.data?.seatBasedPricing) {
    return `${formatAmountCents(plan.amount)}+ / seat`;
  }

  return formatAmountCents(plan.amount);
};

export const mapPlanToTableRow = (plan: PaymentPlan): PlanTableRow => {
  const monthlyAmount = formatMonthlyAmount(plan);
  const annualAmount = plan.recurring === 'ANNUAL' ? formatAmountCents(plan.amount) : '—';

  return {
    id: plan.id,
    name: plan.name,
    ofProjects: formatLimit(plan.data?.maxProjectsAmount),
    ofUsers: formatLimit(plan.data?.maxUsersAmount),
    storageLimit: plan.data?.storageLimit == null ? 'Unlimited' : `${plan.data.storageLimit} GB`,
    mohtlyAmount: monthlyAmount,
    annualAmount,
    externalProductId: plan.externalProductId,
    sourcePlan: plan,
  };
};

export const mapPlansToTableRows = (plans: PaymentPlan[] = []): PlanTableRow[] =>
  plans.map(mapPlanToTableRow);

export const DEFAULT_PLANS_TABLE_META: IMeta = {
  currentPage: 1,
  itemCount: 0,
  itemsPerPage: 10,
  totalItems: 0,
  totalPages: 1,
};
